document.addEventListener('DOMContentLoaded', function() {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReducedMotion) {
        document.querySelectorAll('video[autoplay]').forEach(video => {
            video.pause();
            const pauseButton = video.closest('[class]')?.querySelector('.video-pause-button');
            if (pauseButton) {
                pauseButton.classList.remove('is-playing');
                pauseButton.classList.add('is-paused');
                const btn = pauseButton.querySelector('button');
                if (btn) {
                    btn.setAttribute('aria-label', 'Play video');
                    btn.querySelector('span').innerText = 'Play video';
                }
            }
        });
    }

    const videoPauseButton = document.querySelectorAll('.video-pause-button button');
    if (videoPauseButton.length > 0) {
        videoPauseButton.forEach(button => {
            button.addEventListener('click', function() {
            const video = this.closest('.video-pause-button').parentElement.querySelector('video');
            if (video) {
                if (video.paused) {
                    video.play();
                    this.parentElement.classList.add('is-playing');
                    this.parentElement.classList.remove('is-paused');
                    this.setAttribute('aria-label', 'Pause video');
                    this.querySelector('span').innerText = 'Pause video';
                } else {
                    video.pause();
                    this.parentElement.classList.add('is-paused');
                    this.parentElement.classList.remove('is-playing');
                    this.setAttribute('aria-label', 'Play video');
                    this.querySelector('span').innerText = 'Play video';
                }
                }
            });
        });
    }
});